import * as React from "react"

import Layout from "../components/layout"
import Seo from "../components/seo"
import { Breadcrumb } from "gatsby-plugin-breadcrumb"
import Vimeo from "../components/vimeo"

const RehaLandingPage = props => {
  let seoImage = {
    src: "https://www.emento.de/images/rehab_landing/reha_preview.jpg",
  }
  const {
    breadcrumb: { crumbs },
  } = props.pageContext
  const customCrumbLabel = props.location.pathname
    .replace("-", " ")
    .replace(/\//g, "")

  return (
    <Layout>
      <Seo
        title="Reha"
        description="Rehabilitation mit dem Emento Patient Guide"
        image={seoImage}
        pathname="/reha"
      />
      <div className="content-wide">
        <div className="wide-container">
          <div className="wide-inner">
            <Breadcrumb
              crumbs={crumbs}
              crumbSeparator=" / "
              crumbLabel={customCrumbLabel}
            />
          </div>
        </div>
      </div>
      <div className="content-wide">
        <div className="wide-container">
          <div className="wide-inner rehab">
            <div className="rehab-header">
              <h1>
                Optimierung der Rehabilitation mit dem Emento Patient Guide
              </h1>
              <p>
                Die Digitalisierung verändert die Rehabilitation. Der Emento
                Patient Guide sorgt für eine nahtlose Reise von der Aufnahme bis
                zur Nachsorge mit gezielten, zeitnahen und ansprechenden
                Informationen, die den Prozess für Rehabilitand*innen und
                medizinisches Fachpersonal gleichermaßen klarer und
                unterstützender machen.
              </p>
            </div>
            <div className="rehab-app">
              <div className="rehab-app-left">
                <h2>Ein digitaler Wegbegleiter für die Rehabilitation</h2>
                <p>
                  Der Emento Patient Guide optimiert die Patientenkommunikation
                  und liefert die richtigen Informationen zur richtigen Zeit –
                  vor, während und nach der Rehabilitation. Anstatt die
                  Rehabilitand*innen mit allen Informationen auf einmal zu
                  überfordern, bietet unsere App personalisierte
                  Videobotschaften, Erinnerungen und Behandlungsupdates, was die
                  Beteiligung und die Einhaltung der Aufgaben verbessert.
                </p>
              </div>
              <div className="rehab-app-right">
                <img
                  src="/images/rehab_landing/rehab_images.png"
                  alt="Rehabilitation App"
                />
              </div>
            </div>
            <div className="rehab-bullets">
              <h2>Nahtlos, personalisiert und effizient</h2>
              <ul>
                <li>
                  <img src="/images/rehab_landing/clock.svg" alt="" />
                  <div className="rehab-bullet-text">
                    <b>Rechtzeitige und relevante Informationen</b>
                    <p>
                      Die Rehabilitand*innen erhalten wichtige
                      Benachrichtigungen genau dann, wenn sie sie brauchen.
                    </p>
                  </div>
                </li>
                <li>
                  <img src="/images/rehab_landing/network.svg" alt="" />
                  <div className="rehab-bullet-text">
                    <b>Bessere Behandlungsresultate</b>
                    <p>
                      Eine strukturierte Kommunikation verringert die
                      Informationsflut und verbessert den Behandlungserfolg.
                    </p>
                  </div>
                </li>
                <li>
                  <img src="/images/rehab_landing/chart.svg" alt="" />
                  <div className="rehab-bullet-text">
                    <b>Effizientere Arbeitsabläufe</b>
                    <p>
                      Die Arbeitsbelastung des Personals wird verringert, was
                      einen reibungsloseren Rehabilitationsprozess
                      gewährleistet.
                    </p>
                  </div>
                </li>
                <li>
                  <img src="/images/rehab_landing/lightning.svg" alt="" />
                  <div className="rehab-bullet-text">
                    <b>Gesteigerte Patientenzufriedenheit</b>
                    <p>mit klarer, unterstützender Kommunikation</p>
                  </div>
                </li>
              </ul>
            </div>
            <a
              className="rehab-fair"
              href="https://www.deutsche-rentenversicherung.de/DRV/DE/Experten/Reha-Wissenschaften/Wissensaustausch_Veranstaltungen/Reha-Kolloquium/Reha-Kolloquium-aktuell/kolloquium_aktuell_index.html"
              target="_blank"
              rel="noreferrer"
            >
              <div className="rehab-fair-inner">
                <div className="rehab-fair-image">
                  <img src="/images/rehab_landing/reha_kolloquium.jpg" alt="" />
                </div>
                <div className="rehab-fair-text">
                  <p>18. bis 20. März, 2025</p>
                  <h2>Treffen Sie uns auf dem Reha-Kolloquium</h2>
                </div>
              </div>
              <div className="rehab-fair-logo">
                <img
                  src="/images/rehab_landing/reha_kolloquium_logo.jpg"
                  alt=""
                />
              </div>
            </a>

            <div className="rehab-quote">
              <div className="rehab-quote-image">
                <img src="/images/rehab_landing/rehab_patient.png" alt="" />
              </div>
              <div className="rehab-quote-text">
                <p className="rehab-quote-text-quote">
                  “Der Patient Guide machte mich unabhängiger und durch die
                  richtigen Übungen kam ich schneller wieder auf die Beine.”
                </p>
                <div className="rehab-quote-author">
                  <b>Rasmus Odgaard Thorup</b>
                  <p>
                    ehemaliger Rehabilitand, Hüftrehabilitation North Zealand
                    Hospital, Dänemark
                  </p>
                </div>
              </div>
            </div>
            <div className="rehab-article-link">
              <div className="rehab-article-link-left">
                <div className="rehab-article-link-left-label">Artikel</div>
                Erleichtern Sie die Rehabilitation mit dem Emento Patient Guide
                - Sicherheit und Übersicht von Anfang bis Ende
              </div>
              <a
                className="rehab-article-link-right"
                href="/blog/erleichtern-sie-die-rehabilitation-mit-dem-emento-patient-guide-sicherheit/"
              >
                <img src="/images/rehab_landing/arrow-right.svg" alt="" />
                <p>mehr lesen</p>
              </a>
            </div>
            <div className="rehab-integrations">
              <div className="rehab-integrations-left">
                <h2>
                  Integrieren Sie den Emento Patient Guide in Ihren Workflow
                </h2>
                <p>
                  Durch die Integration in bestehende Systeme, einschließlich
                  der{" "}
                  <b>
                    <a
                      href="https://www.magrathea.eu/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Magrathea Informatik GmbH
                    </a>
                  </b>
                  , ermöglicht der Emento Patient Guide
                  Rehabilitationseinrichtungen, die Patientenerfahrung zu
                  verbessern, Abläufe zu rationalisieren und die digitale
                  Transformation voranzutreiben.
                </p>
              </div>
              <div className="rehab-integrations-right">
                <a
                  href="https://www.magrathea.eu/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src="/images/rehab_landing/magrathea.png" alt="" />
                </a>
              </div>
            </div>
            <div className="rehab-cta">
              <div className="rehab-cta-left">
                <img src="/images/rehab_landing/rocket.svg" alt="" />
                <p>
                  Sind Sie bereit, die Rehabilitation zu revolutionieren?
                  <br />
                  <em>Kontaktieren Sie uns noch heute!</em>
                </p>
              </div>
              <div className="rehab-cta-right">
                <a className="rehab-cta-person" href="mailto:dj@emento.de">
                  <img
                    src="https://emento.dk/images/portraits/2022/diana.jpg"
                    alt=""
                  />
                  <div className="rehab-cta-person-text">
                    <b>Diana Juchem</b>
                    <p>Sales Manager</p>
                  </div>
                </a>
                <a className="rehab-cta-person" href="mailto:ml@emento.de">
                  <img
                    src="https://emento.dk/images/portraits/2022/melanie.jpg"
                    alt=""
                  />
                  <div className="rehab-cta-person-text">
                    <b>Melanie Lau</b>
                    <p>Sales Manager</p>
                  </div>
                </a>
              </div>
            </div>
            <div className="rehab-video">
              <div className="rehab-video-text">
                <h2>Erleben Sie den Emento Patient Guide in Aktion</h2>
                <p>
                  Sehen Sie, wie der Emento Patient Guide den Rehabilitand*innen
                  hilft, bei ihrer Rehabilitation auf Kurs zu bleiben.
                </p>
              </div>
              <div className="rehab-video-player">
                <div className="video-player">
                  <Vimeo
                    videoSrcURL="https://player.vimeo.com/video/702502385?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                    videoTitle="Emento Patient Guide"
                    iframeStyle="video-iframe"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default RehaLandingPage
